export default () => () => ({
    type: 'getForTreeWithParents',
    payload: ''
});
